import { useEffect, useState } from 'react';

import { LookupAutocompleteView } from '@/shared/ui/molecules/LookupAutocomplete';

import { useCourseSearchDropdown } from '../../../hooks/useCourseSearchDropdown';

export interface CourseAutocompleteProps {
  /** ID do curso selecionado; `null` quando nada. */
  readonly value: number | null;
  /** Rótulo da seleção corrente. */
  readonly selectedLabel?: string;
  /** Notifica o novo ID e rótulo (`null`/`''` ao limpar). */
  readonly onChange: (id: number | null, label: string) => void;
  readonly label: string;
  readonly placeholder: string;
  readonly hasError?: boolean;
}

/**
 * Autocomplete de Curso para o modal "Adicionar Turma" (busca server-side via
 * {@link useCourseSearchDropdown}, base compartilhada `LookupAutocompleteView`).
 * Usado só para restringir a busca de Turma por `courseId` — o curso em si não
 * é persistido em `classStudents`.
 */
export function CourseAutocomplete({
  value,
  selectedLabel: selectedLabelProp = '',
  onChange,
  label,
  placeholder,
  hasError,
}: CourseAutocompleteProps) {
  const [search, setSearch] = useState('');
  const [inputText, setInputText] = useState(selectedLabelProp);
  const { options, isQuerySuccess } = useCourseSearchDropdown(search);

  useEffect(() => {
    setInputText(selectedLabelProp);
  }, [selectedLabelProp]);

  return (
    <LookupAutocompleteView
      label={label}
      placeholder={placeholder}
      value={value !== null ? String(value) : ''}
      selectedLabel={inputText}
      options={options}
      isQuerySuccess={isQuerySuccess}
      search={search}
      hasError={hasError ?? false}
      onSearchChange={setSearch}
      onSelect={(id, itemLabel) => {
        onChange(id ? Number(id) : null, itemLabel);
        setInputText(itemLabel);
        setSearch('');
      }}
      onClear={() => {
        onChange(null, '');
        setInputText('');
        setSearch('');
      }}
    />
  );
}
